import { BatchHttpLink } from "@apollo/client/link/batch-http";
import { getCustomFetchFn } from "Utils/UrlHelpers";
import { split, createHttpLink } from "@apollo/client";
import config from "config";

// Add operation names here to redirect them to your local backend during development.
// Only takes effect when PLATFORM_ENV=development (i.e., `npm start`).
// Example: ["getCourseDetails", "updateUnitPlan"]
const LOCAL_BACKEND_URL = "http://localhost:3001";
const LOCAL_OPERATIONS = [];

const withCredentials = !!config.withCredentials;
const batchHttpLink = withCredentials
  ? new BatchHttpLink({
      credentials: "include",
      fetch: getCustomFetchFn(),
      includeExtensions: true,
    })
  : new BatchHttpLink({
      fetch: getCustomFetchFn(),
      includeExtensions: true,
    });
const httpLink = withCredentials
  ? createHttpLink({
      credentials: "include",
      fetch: getCustomFetchFn(),
      includeExtensions: true,
    })
  : createHttpLink({
      fetch: getCustomFetchFn(),
      includeExtensions: true,
    });

const localHttpLink = createHttpLink({
  credentials: "include",
  fetch: getCustomFetchFn({ overrideBaseurl: LOCAL_BACKEND_URL }),
  includeExtensions: true,
});

const defaultNetworkLink = split(
  operation => {
    const context = operation.getContext();
    return context.useHttpLink === true || config.useHttpLink;
  },
  httpLink,
  batchHttpLink
);

const networkLink = split(
  op => {
    return (
      config.env === "development" &&
      LOCAL_OPERATIONS.length > 0 &&
      LOCAL_OPERATIONS.includes(op.operationName)
    );
  },
  localHttpLink,
  defaultNetworkLink
);
export default networkLink;
